// extracted by mini-css-extract-plugin
export default {"block":"MenOnLogin_block__T5ymq","men":"MenOnLogin_men__jcl67"};